
import React from "react";

export const TeacherPageHeader: React.FC = () => {
  return (
    <div className="space-y-1">
      <h1 className="text-2xl font-bold text-[#272f3c]">Professores</h1>
      <p className="text-[#67748a]">Gerenciamento de professores da plataforma</p>
    </div>
  );
};

export default TeacherPageHeader;
